$(document).ready(function () {
  const essentialsSwiper = new Swiper('.sb-essentials__swiper', {
    slidesPerView: 'auto',
    spaceBetween: 12,
    freeMode: true,
    breakpoints: {
      576: {
        spaceBetween: 16,
      },
      992: {
        spaceBetween: 20,
      },
    },
  });

  const categorySwiper = new Swiper('.sb-category__swiper', {
    slidesPerView: 'auto',
    spaceBetween: 12,
    freeMode: true,
    breakpoints: {
      576: {
        spaceBetween: 16,
      },
      992: {
        spaceBetween: 20,
      },
    },
  });

  // FAQ Accordion
  $('.sb-faq__question-wrapper').on('click', function() {
    const $item = $(this).closest('.sb-faq__item');
    const $answerWrapper = $item.find('.sb-faq__answer-wrapper');
    
    // Toggle active class and slide
    if ($item.hasClass('active')) {
      $answerWrapper.slideUp(300, function() {
        $item.removeClass('active');
        $answerWrapper.css('display', ''); // Reset display style set by slideUp
      });
    } else {
      // Close all others (optional, depending on intended behavior - screenshot only shows one open but it doesn't hurt to let them open multiple. Let's just toggle this one independently)
      
      // Let's implement independent toggling.
      $('.sb-faq__item').removeClass('active');
      $item.addClass('active');
      $answerWrapper.hide().slideDown(300, function() {
        $answerWrapper.css('display', '');
      });
    }
  });

  // Assign classes before Swiper duplicates them for smooth looping
  $('.sb-auto-slider__slide').each(function(index) {
    $(this).addClass('sb-auto-slider__slide--' + ((index % 4) + 1));
  });

  const autoSliderSwiper = new Swiper('.sb-auto-slider__swiper', {
    slidesPerView: 'auto',
    spaceBetween: 6,
    loop: true,
    speed: 3000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    allowTouchMove: false,
    breakpoints: {
      576: {
        spaceBetween: 10,
      },
     
    },
  });

  let autoSliderTarget = null;
  let autoSliderTimeout = null;

  $('.sb-auto-slider__swiper').hover(
    function() {
      clearTimeout(autoSliderTimeout);
      autoSliderTarget = autoSliderSwiper.translate;
      autoSliderSwiper.autoplay.stop();
      autoSliderSwiper.setTranslate(autoSliderSwiper.getTranslate());
      autoSliderSwiper.setTransition(0);
    },
    function() {
      let swiper = autoSliderSwiper;
      let currentTranslate = swiper.getTranslate();
      let distance = Math.abs(currentTranslate - autoSliderTarget);
      
      let slideWidth = swiper.slidesSizesGrid[0] || 136;
      let time = (distance / slideWidth) * swiper.params.speed;
      
      swiper.setTransition(time);
      swiper.setTranslate(autoSliderTarget);
      
      autoSliderTimeout = setTimeout(() => {
        if (!swiper.destroyed) {
          swiper.autoplay.start();
        }
      }, time);
    }
  );

  // const productBenefitsSwiper = new Swiper('.sb-product-benefits__swiper', {
  //   // slidesPerView: 'auto',
  //   slidesPerView: 4,
  // spaceBetween: 0,
  // loop: true,
  //   navigation: {
  //     nextEl: '.sb-product-benefits__arrow--next',
  //     prevEl: '.sb-product-benefits__arrow--prev',
  //   },
  // });

  const productBenefitsSwiper = new Swiper('.sb-product-benefits__swiper', {
  loop: true,
  spaceBetween: 0,

  // Default (mobile)
  slidesPerView: 1,

  breakpoints: {
    576: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 4,
    },
  },

  navigation: {
    nextEl: '.sb-product-benefits__arrow--next',
    prevEl: '.sb-product-benefits__arrow--prev',
  },
});

  // Video Play Logic
  $('.sb-featured__play-icon').on('click', function() {
    const $video = $(this).siblings('.sb-featured__video-img');
    const videoElement = $video[0];
    
    if (videoElement) {
      $(this).fadeOut(300);
      videoElement.play();
    }
  });

  $('.sb-featured__video-img').on('click', function() {
    if (!this.paused) {
      this.pause();
      $(this).siblings('.sb-featured__play-icon').fadeIn(300);
    }
  });

  // Product Gallery Logic
  const productGallerySwiper = new Swiper('.sb-product-gallery__swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: '.sb-product-gallery__arrow--next',
      prevEl: '.sb-product-gallery__arrow--prev',
    },
    pagination: {
      el: '.sb-product-gallery__pagination',
      clickable: true,
    },
    breakpoints: {
      992: {
        enabled: false,
        spaceBetween: 8,
      }
    }
  });

  // Clickable thumbs on desktop
  $('.sb-product-gallery__slide').on('click', function() {
    if (window.innerWidth > 991) {
      const imgSrc = $(this).data('img');
      const $mainImg = $('#sb-gallery-main-img');
      
      $mainImg.fadeTo(150, 0.5, function() {
        $mainImg.attr('src', imgSrc).fadeTo(150, 1);
      });
    }
  });
});
